module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "appliances.50bf90dd.jpg" + "?" + Date.now();